import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import generateUUID from 'web-app/util/uuid';
import {getApolloClient} from 'web-app/api/clients/famly-app';
import {KeepAlive} from 'web-app/react/session/auto-logout/queries';
import {type KeepAliveMutation} from 'web-app/react/session/auto-logout/__generated__/queries.api-types';

export default class AccountApi {
    static extendSession(context) {
        return getApolloClient().mutate<KeepAliveMutation>({
            mutation: KeepAlive,
            context,
        });
    }

    static fetchMainMenu() {
        // uuid is set to make sure that enterprise caches don't serve the content of other users
        return RESTClient.getAuthenticated('v2/sidebar', {uuid: generateUUID()});
    }
}
